module.exports = __webpack_public_path__ + "static/80-a139aa8f282f740161f97549d5efca22.png";